import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import {
  getDepartmentList,
  createDepartment,
} from "../../../../services/workspace/department.service";
import { useEffect, useState, useMemo, useCallback } from "react";
import CommonForm from "../../../components/form/form";
import { convertToLabelValue } from "../../../../utils/common";
import toast from "react-hot-toast";
import { getDesignationList } from "../../../../services/workspace/designation.service";
import {
  createUser,
  updateUser,
  getUserDetail,
  getUserDetailProfile,
} from "../../../../services/workspace/user.service";
import { useParams, useNavigate } from "react-router-dom";
import {
  getCountryOptions,
  getStateOptions,
  normalizeCountryValue,
  findCountryByState,
} from "../../../../utils/countryStateData";
import SalaryCard from "./components/SalaryCard";
import Loading from "../../../components/skeleton/loading";
import { getSalaryStructureList } from "../../../../services/workspace/salaryStructure.service";

const actions_type = {
  ADD_EDIT: "ADD_EDIT",
};

const AddStaffDirectory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isEditValue, setIsEditValue] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [allDesignationsRaw, setAllDesignationsRaw] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [sameAsCurrent, setSameAsCurrent] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCountry2, setSelectedCountry2] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [stateOptions2, setStateOptions2] = useState([]);
  const [salaryStructureList, setSalaryStructureList] = useState([]);

  const getEighteenYearsAgoYMD = () => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 18);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const items = [
    { label: "Staff Directory", path: "/hr/staff-directory" },
    { label: id ? "Edit Staff Directory" : "Add Staff Directory", path: "" },
  ];

  const {
    action,
    handleSearchChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
  } = useCommonFetch(getDepartmentList, {
    dataPath: "department.data",
    totalPath: "department.meta.total",
    errorMessage: "Failed to fetch department data!",
    debounceDelay: 500,
  });

  const handleAddDepartmentClick = () => {
    openModal(null, "ADD_DEPARTMENT");
  };

  const handleDepartmentChange = (departmentId) => {
    setSelectedDepartment(departmentId);
    if (departmentId) {
      const filtered = allDesignationsRaw.filter(
        (d) => String(d?.department?.id ?? d?.department_id ?? "") === String(departmentId)
      );
      setDesignationList(convertToLabelValue(filtered));
    } else {
      setDesignationList([]);
    }
  };

  const handleCountryChange = (countryValue, setFieldValue) => {
    setSelectedCountry(countryValue);
    const states = getStateOptions(countryValue);
    setStateOptions(states);

    // Clear state field when country changes
    if (setFieldValue) {
      setFieldValue("state", "");
    }

    // If same as current is checked, update permanent address country and states
    if (sameAsCurrent && setFieldValue) {
      setFieldValue("country2", countryValue);
      setSelectedCountry2(countryValue);
      setStateOptions2(states);
      setFieldValue("state2", "");
    }
  };

  const handleCountry2Change = (countryValue, setFieldValue) => {
    setSelectedCountry2(countryValue);
    const states = getStateOptions(countryValue);
    setStateOptions2(states);

    // Clear state field when country changes
    if (setFieldValue) {
      setFieldValue("state2", "");
    }
  };

  // const fetchSalaryStructures = () => {
  //   getSalaryStructureList({ status: 1 })
  //     .then((response) => {
  //       const list = response?.salaryStructure?.data || [];
  //       const options = list.map((item) => ({
  //         label: `${item.name} (₹${item.annual_ctc})`,
  //         value: item.id || item.uuid,
  //       }));
  //       setSalaryStructureList(options);
  //     })
  //     .catch((error) => {
  //       console.error("Failed to fetch salary structures:", error);
  //       toast.error("Failed to load salary structures. Please refresh the page.");
  //       setSalaryStructureList([]);
  //     });
  // };

  // Form fields - memoized to prevent recreation on every render
  const comprehensiveFields = useMemo(
    () => [
      {
        type: "section_header",
        name: "contact_section",
        label: "General Information",
        colSpan: 12,
      },
      {
        name: "name",
        label: "First Name",
        type: "text",
        placeholder: "Enter first name",
        required: true,
        minLength: 2,
        maxLength: 40,
        colSpan: 3,
      },
      {
        name: "last_name",
        label: "Last Name",
        type: "text",
        placeholder: "Enter last name",
       
        minLength: 2,
        maxLength: 40,
        colSpan: 3,
      },
      {
        name: "phone",
        label: "Phone Number",
        type: "contact",
        required: true,
        countryCodeName: "country_code",
        placeholder: "Enter phone number",
        colSpan: 3,
      },
      {
        name: "phone2",
        label: "Alternate Phone Number",
        type: "contact",
        countryCodeName: "country_code2",
        placeholder: "Enter alternate phone number",
        colSpan: 3,
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        placeholder: "Enter email",
        required: true,
        colSpan: 3,
      },

      {
        name: "dob",
        label: "Date Of Birth",
        type: "date",
        placeholder: "Enter date of birth",
        required: true,
        maxDate: id
          ? new Date() // Allow any past date when editing
          : new Date(new Date().setFullYear(new Date().getFullYear() - 18)), // Only restrict for new staff
        initialValue: id ? undefined : getEighteenYearsAgoYMD(), // Only set initial value for new staff
        colSpan: 3,
      },

      {
        name: "date_of_joining",
        label: "Joining Date",
        type: "date",
        placeholder: "Enter joining date",
        required: true,
        colSpan: 3,
      },

      {
        name: "department_name",
        label: "Department Name",
        type: "select",
        placeholder: "Enter department name",
        required: true,
        // addmoreClick: true,
        options: departmentList,
        // onAddMore: handleAddDepartmentClick,
        onChange: (value) => handleDepartmentChange(value?.value),
        colSpan: 3,
      },
      {
        name: "designation_name",
        label: "Designation Name",
        type: "select",
        placeholder: "Select designation",
        required: true,
        options: designationList,
        showIf: () => !!selectedDepartment,
        colSpan: 3,
      },
      // {
      //   name: "salary_structure_id",
      //   label: "Salary Structure",
      //   type: "select",
      //   placeholder: "Select salary structure",
      //   required: false,
      //   options: salaryStructureList,
      //   onRefresh: fetchSalaryStructures,
      //   colSpan: 3,
      // },
      {
        name: "gender",
        label: "Gender",
        type: "select",
        placeholder: "Select gender",
        required: true,
        colSpan: 3,
        options: [
          { label: "Male", value: "male" },
          { label: "Female", value: "female" },
          { label: "Other", value: "other" },
        ],
      },
      {
        name: "father_name",
        label: "Father Name",
        type: "text",
        placeholder: "Enter father name",

        minLength: 2,
        maxLength: 40,
        colSpan: 3,
      },
      {
        name: "mother_name",
        label: "Mother Name",
        type: "text",
        placeholder: "Enter mother name",

        minLength: 2,
        maxLength: 40,
        colSpan: 3,
      },
      {
        name: "blood_group",
        label: "Blood Group",
        type: "select",
        options: [
          { label: "A+", value: "A+" },
          { label: "A-", value: "A-" },
          { label: "B+", value: "B+" },
          { label: "B-", value: "B-" },
          { label: "AB+", value: "AB+" },
          { label: "AB-", value: "AB-" },
          { label: "O+", value: "O+" },
          { label: "O-", value: "O-" },
        ],
        colSpan: 3,
      },
      {
        name: "marital_status",
        label: "Marital Status",
        type: "select",
        placeholder: "Select marital status",

        // initialValue: "unmarried",
        colSpan: 3,
        options: [
          { label: "Unmarried", value: "unmarried" },
          { label: "Married", value: "married" },
          { label: "Divorced", value: "divorced" },
          { label: "Widowed", value: "widowed" },
        ],
      },
      {
        name: "date_of_marriage",
        label: "Date Of Marriage",
        type: "date",
        placeholder: "Enter marriage date",
        required: false,
        colSpan: 3,
        maxDate: new Date(), // today's date
        // disable dates before (dob + 21 years)
        minDate: (values) => {
          if (!values?.dob) return null; // if no dob, allow all
          
          const dob = new Date(values.dob);
          if (isNaN(dob.getTime())) return null;
          
          const minMarriageDate = new Date(dob);
          minMarriageDate.setFullYear(dob.getFullYear() + 21);
          return minMarriageDate;
        },
        showIf: (values) => values.marital_status === "married",
      },
      {
        name: "partner_name",
        label: "Partner Name",
        type: "text",
        placeholder: "Enter partner name",
        required: false,
        showIf: (values) => values.marital_status === "married",
        colSpan: 3,
      },
      {
        type: "section_header",
        name: "contact_section",
        label: "Contact Information",
        colSpan: 12,
      },
      {
        name: "country",
        label: "Country",
        type: "select",
        placeholder: "Select country",
        colSpan: 3,
        options: getCountryOptions(),
        onChange: (val, _a, setFieldValue) => {
          const countryValue = val?.value ?? "";
          handleCountryChange(countryValue, setFieldValue);
        },
      },
      {
        name: "state",
        label: "State",
        colSpan: 3,
        type: "select",
        placeholder: "Select state",

        options: stateOptions,
        disabled: !selectedCountry,
        onChange: (val, _a, setFieldValue) => {
          if (sameAsCurrent) setFieldValue("state2", val?.value ?? "");
        },
      },
      {
        name: "city",
        label: "City",
        type: "text",
        placeholder: "",

        maxLength: 40,
        colSpan: 3,
        onChange: (e, _a, setFieldValue) => {
          if (sameAsCurrent) setFieldValue("city2", e?.target?.value ?? "");
        },
      },
      {
        name: "pincode",
        label: "Pincode",
        type: "text",
        placeholder: "",

        colSpan: 3,
        onChange: (e, _a, setFieldValue) => {
          if (sameAsCurrent) setFieldValue("pincode2", e?.target?.value ?? "");
        },
        // validation: (rule) =>
        //   rule.test(
        //     "pincode-length",
        //     "The pincode field must be between 4 and 10 digits and must not contain decimals or special characters.",

        //     (value) => {
        //       if (value === undefined || value === null || value === "")
        //         return true;

        //       // allow only digits
        //       const s = String(value);

        //       // check if it contains only digits and is between 4–10
        //       return /^\d{4,10}$/.test(s);
        //     }
        //   ),
      },
      {
        name: "address",
        label: "Address",
        type: "textarea",

        placeholder: "Write description here...",
        maxLength: 300,
        colSpan: 3,
        onChange: (e, _a, setFieldValue) => {
          if (sameAsCurrent) setFieldValue("address2", e?.target?.value ?? "");
        },
      },
      {
        name: "same_as_current",
        label: "Permanent address same as current address",
        type: "checkbox",

        initialValue: false,
        onChange: (val) => {
          const checked = val?.target?.checked ?? Boolean(val);
          setSameAsCurrent(checked);
        },
        colSpan: 12,
      },
      // Permanent address fields
      {
        name: "country2",
        label: "Country (Permanent)",
        type: "select",
        placeholder: "Select country",
        colSpan: 3,
        options: getCountryOptions(),
        disabled: sameAsCurrent,
        onChange: (val, _a, setFieldValue) => {
          const countryValue = val?.value ?? "";
          handleCountry2Change(countryValue, setFieldValue);
        },
      },
      {
        name: "state2",
        label: "State (Permanent)",
        type: "select",
        placeholder: "Select state",
        colSpan: 3,
        options: stateOptions2,
        disabled: sameAsCurrent || !selectedCountry2,
      },
      {
        name: "city2",
        label: "City (Permanent)",
        type: "text",
        placeholder: "",
        colSpan: 3,
        maxLength: 40,
        disabled: sameAsCurrent,
      },
      {
        name: "pincode2",
        label: "Pincode (Permanent)",
        type: "text",
        placeholder: "",
        colSpan: 3,
        disabled: sameAsCurrent,
        // validation: (rule) =>
        //   rule.test(
        //     "pincode2-length",
        //     "The pincode field must be between 4 and 10 digits.",
        //     (value) => {
        //       if (value === undefined || value === null || value === "")
        //         return true;
        //       const s = String(value).replace(/\D/g, "");
        //       return s.length >= 4 && s.length <= 10;
        //     }
        //   ),
      },
      {
        name: "address2",
        label: "Address (Permanent)",
        type: "textarea",
        placeholder: "Write description here...",
        maxLength: 300,
        colSpan: 3,
        disabled: sameAsCurrent,
      },
    ],
    [
      id,
      departmentList,
      designationList,
      selectedDepartment,
      allDesignationsRaw,
      selectedCountry,
      selectedCountry2,
      stateOptions,
      stateOptions2,
      sameAsCurrent,
    ]
  );

  const handleSubmit = async (
    values,
    { setSubmitting, resetForm, setErrors }
  ) => {
    const getValue = (val) =>
      val && typeof val === "object" && "value" in val ? val.value : val;
    try {
      const payload = {
        type: 2, // 2 -> staff
        department_id:
          getValue(values.department_name) || selectedDepartment || null,
        designation_id: getValue(values.designation_name) || null,
        name: values.name,
        last_name: values.last_name,
        email: values.email,
        password: values.password || "12345678",
        country_code: values.country_code,
        phone: values.phone,
        country_code2: values.country_code2,
        phone2: values.phone2,
        father_name: values.father_name,
        mother_name: values.mother_name,
        marital_status: getValue(values.marital_status),
        date_of_marriage: values.date_of_marriage || null,
        spouse_name: values.partner_name || null,
        address: values.address,
        country: getValue(values.country),
        state: getValue(values.state),
        city: values.city,
        pincode: values.pincode,
        gender: getValue(values.gender),
        dob: values.dob,
        blood_group: values.blood_group || null,
        emp_type: values.emp_type || "full-time",
        joining_at: values.date_of_joining,
        // Permanent address fields
        address2: values.address2,
        state2: getValue(values.state2),
        city2: values.city2,
        pincode2: values.pincode2,
        country2: getValue(values.country2),
        // Salary structure
        // salary_structure_id: getValue(values.salary_structure_id) || null,
      };

      if (id) {
        const res = await handleUpdate(payload, id, updateUser);
        if (res?.success) {
          resetForm();
          navigate("/hr/staff-directory", { replace: true });
        }
      } else {
        const res = await handleCreate(payload, createUser);
        if (res?.success) {
          resetForm();
          navigate("/hr/staff-directory", { replace: true });
        }
      }
    } catch (err) {
              // Error logged for debugging
      if (err?.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }

      if (err?.response?.data?.message) {
        setErrors({ email: err.response.data.message });
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    // Form cancellation logic can be added here if needed
  };

  useEffect(() => {
    fetchDepartment();

    // Initialize with India as default
    const defaultCountry = "india";
    setSelectedCountry(defaultCountry);
    setStateOptions(getStateOptions(defaultCountry));
    setSelectedCountry2(defaultCountry);
    setStateOptions2(getStateOptions(defaultCountry));
  }, []);

  // Extract fetchUserForEdit as a reusable function
  const fetchUserForEdit = useCallback(async () => {
    if (!id) return;
    try {
      const response = await getUserDetailProfile(id, {
        with: "department,designation",
        additional_info: true,
      });
      const user = response?.user || response?.data?.user || {};

        const departmentId =
          user?.user_info?.designation?.department?.id ??
          user?.department_id ??
          null;
        if (departmentId) {
          setSelectedDepartment(departmentId);
          // allDesignationsRaw populated by fetchDepartment on mount
          const filtered = allDesignationsRaw.filter(
            (d) => String(d?.department?.id ?? d?.department_id ?? "") === String(departmentId)
          );
          setDesignationList(filtered.length ? convertToLabelValue(filtered) : await fetchDesignation(departmentId));
        }

        const toYMD = (v) => {
          if (!v) return "";
          // Handle different date formats
          if (typeof v === "string") {
            // If it's already in YYYY-MM-DD format, return as is
            if (v.match(/^\d{4}-\d{2}-\d{2}$/)) {
              return v;
            }
            // If it's a longer string, extract first 10 characters
            if (v.length >= 10) {
              return v.substring(0, 10);
            }
          }
          // Handle Date objects
          if (v instanceof Date) {
            const year = v.getFullYear();
            const month = String(v.getMonth() + 1).padStart(2, "0");
            const day = String(v.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
          }
          return v || "";
        };
        const norm = (s) =>
          typeof s === "string"
            ? s.trim().toLowerCase().replace(/\s+/g, " ")
            : s ?? "";
        const strip = (s) =>
          norm(s)
            .replace(/[_\-]/g, "")
            .replace(/\s+/g, "")
            .replace(/&/g, "and");

        const getFieldOptions = (fieldName) => {
          const f = comprehensiveFields.find((x) => x.name === fieldName);
          return Array.isArray(f?.options) ? f.options : [];
        };

        const resolveOptionValue = (fieldName, raw) => {
          const options = getFieldOptions(fieldName);
          if (!options.length) return raw ?? "";
          if (raw === null || raw === undefined || raw === "") return "";
          // Try direct value match
          const direct = options.find((o) => String(o.value) === String(raw));
          if (direct) return direct.value;
          // Try by normalized label/value comparison
          const rawStr = String(raw);
          const nRaw = strip(rawStr);
          let found = options.find(
            (o) => strip(o.value) === nRaw || strip(o.label) === nRaw
          );
          if (found) return found.value;
          // Fallback: contains-based
          found = options.find(
            (o) =>
              strip(o.label).includes(nRaw) || nRaw.includes(strip(o.label))
          );
          return found ? found.value : "";
        };

        const resolveCountryValue = (raw) => {
          if (!raw) return "";
          const normalized = normalizeCountryValue(raw);
          const countryOptions = getCountryOptions();
          const found = countryOptions.find((c) => c.value === normalized);
          return found ? found.value : "";
        };

        // Marital status specific normalization (API may send 'single')
        const normalizeMarital = (val) => {
          const v = norm(val);
          if (v === "single") return "unmarried";
          return resolveOptionValue("marital_status", v) || v;
        };

        // Resolve country values first
        const countryValue = resolveCountryValue(user?.country || "");
        const country2Value = resolveCountryValue(user?.country2 || "");

        // Set up states based on countries
        if (countryValue) {
          setSelectedCountry(countryValue);
          const states = getStateOptions(countryValue);
          setStateOptions(states);
        }

        if (country2Value) {
          setSelectedCountry2(country2Value);
          const states2 = getStateOptions(country2Value);
          setStateOptions2(states2);
        }

        // Debug date values - removed console.log for production

        const mapped = {
          id: user?.id ?? user?.uuid ?? id,
          name: user?.first_name ?? "",
          last_name: user?.last_name ?? "",
          phone: user?.phone ?? "",
          phone2: user?.phone2 ?? "",
          email: user?.email ?? "",
          date_of_joining: toYMD(user?.joining_at ?? user?.joining_at),
          // department_name: departmentId ?? "",
          department_name: user?.department?.id ?? user?.department_id ?? "",
          designation_name: user?.designation?.id ?? user?.designation_id ?? "",
          dob: toYMD(user?.dob ?? user?.date_of_birth),
          gender:
            resolveOptionValue(
              "gender",
              norm(user?.gender || user?.gender || "")
            ) || "",
          father_name: user?.father_name ?? "",
          mother_name: user?.mother_name ?? "",
          blood_group: user?.blood_group ?? "",
          marital_status: normalizeMarital(user?.marital_status || ""),
          date_of_marriage: toYMD(user?.date_of_marriage),
          partner_name: user?.spouse_name ?? "",
          country: countryValue,
          state: user?.state ?? "",
          city: user?.city ?? "",
          pincode: user?.pincode ?? "",
          address: user?.address ?? "",
          country2: country2Value,
          state2: user?.state2 ?? "",
          city2: user?.city2 ?? "",
          pincode2: user?.pincode2 ?? "",
          address2: user?.address2 ?? "",
          country_code: user?.country_code || "+91",
          country_code2: user?.country_code2 || "+91",
          // Salary structure
          // salary_structure_id: user?.salary_structure_id || user?.salary_structure?.id || null,
        };

        // Debug info - removed console.log for production
        setIsEditValue(mapped);
      } catch (e) {
        toast.error("Failed to fetch user details!");
      }
    }, [id, allDesignationsRaw]);

  // Call fetchUserForEdit when id changes
  useEffect(() => {
    fetchUserForEdit();
  }, [fetchUserForEdit]);

  const fetchDepartment = async () => {
    try {
      const [deptRes, desigRes] = await Promise.all([
        getDepartmentList({}),
        getDesignationList({ with: "department" }),
      ]);

      const deptData = deptRes?.department?.data || [];
      const desigData = Array.isArray(desigRes?.designation?.data)
        ? desigRes.designation.data
        : [];

      // Cache all designations for filtering on dept change (no extra API call)
      setAllDesignationsRaw(desigData);

      // Build count map: deptId → number of designations
      const countMap = {};
      desigData.forEach((d) => {
        const deptId = String(d?.department?.id ?? d?.department_id ?? "");
        if (deptId) countMap[deptId] = (countMap[deptId] || 0) + 1;
      });

      // Department options: disabled if they have no designations
      const options = deptData.map((dept) => {
        const count = countMap[String(dept.id)] || 0;
        return {
          label: dept.name,
          value: dept.id,
          isDisabled: count === 0,
          count,
        };
      });

      setDepartmentList(options);
    } catch {
      toast.error("Failed to fetch department data!");
      setDepartmentList([]);
    }
  };

  const fetchDesignation = async (departmentId = null) => {
    if (!departmentId) return [];
    // Filter from cached raw list — no extra API call needed
    const filtered = allDesignationsRaw.filter(
      (d) => String(d?.department?.id ?? d?.department_id ?? "") === String(departmentId)
    );
    const options = convertToLabelValue(filtered);
    setDesignationList(options);
    return options;
  };

  // Fetch salary structures on mount
  // useEffect(() => {
  //   fetchSalaryStructures();
  // }, []);

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader breadcrumbs={items} />

      <div className={"flex flex-col gap-2 bg-white p-4 rounded-md"}>
        {/* Debug info removed for production */}

        {id && !isEditValue ? (
          <Loading height="min-h-[280px]" message="Loading staff details..." />
        ) : (
          <CommonForm
            fields={comprehensiveFields}
            initialData={
              isEditValue
                ? {
                    country_code: "+91",
                    country_code2: "+91",
                    country: "india",
                    country2: "india",
                    ...isEditValue,
                  }
                : {
                    country_code: "+91",
                    country_code2: "+91",
                    country: "india",
                    country2: "india",
                  }
            }
            key={`${id || "new"}-${isEditValue ? "edit" : "add"}`} // Force re-render when switching between add/edit modes
            enableReinitialize={true} // Ensure form reinitializes when initialData changes
            onSubmit={handleSubmit}
            submitButtonText="Submit"
            onCancel={handleCancel}
            cancelButtonText="cancel"
            columnsPerRow={4}
            gap="gap-4"
            rowClassName=""
            fieldClassName="bg-white p-3 rounded shadow-sm"
            onValuesChange={(values, setFieldValue) => {
              const checked = Boolean(values?.same_as_current);
              if (checked !== sameAsCurrent) setSameAsCurrent(checked);
              
              // Handle same as current address logic
              if (checked) {
                const map = [
                  ["country", "country2"],
                  ["state", "state2"],
                  ["city", "city2"],
                  ["pincode", "pincode2"],
                  ["address", "address2"],
                ];
                map.forEach(([src, dst]) => {
                  const srcVal = values?.[src] ?? "";
                  const dstVal = values?.[dst] ?? "";
                  if (srcVal !== dstVal) setFieldValue(dst, srcVal);
                });

                // Handle country change for permanent address
                const currentCountry = values?.country ?? "";
                if (currentCountry && currentCountry !== selectedCountry2) {
                  setSelectedCountry2(currentCountry);
                  const states = getStateOptions(currentCountry);
                  setStateOptions2(states);
                  setFieldValue("state2", values?.state ?? "");
                }
              }
            }}
          />
        )}

        {/* Salary Card - Only show when editing existing staff */}
        {/* {id && isEditValue && (
          <div className="mt-4">
            <SalaryCard
              employeeId={id}
              employeeData={isEditValue}
              onUpdate={async (newSalary) => {
                // Refresh staff data after salary structure assignment
                await fetchUserForEdit();
                toast.success("Salary structure assigned successfully! Staff data refreshed.");
              }}
            />
          </div>
        )} */}
      </div>

      <CommonModal
        open={action === "ADD_DEPARTMENT"}
        onClose={closeModal}
        title="Add New Department"
      >
        <CommonForm
          fields={[
            {
              name: "name",
              label: "Department Name",
              type: "text",
              required: true,
            },
            {
              name: "abrv",
              label: "Abbreviation",
              type: "text",
              required: true,
            },
            {
              name: "description",
              label: "Description",
              type: "textarea",
              required: false,
            },
          ]}
          onSubmit={async (values, formikHelpers) => {
            await handleCreate(values, createDepartment, {
              successMessage: "Department created!",
              errorMessage: "Failed to create department!",
            });

            closeModal();
            fetchData();
            formikHelpers.setSubmitting(false);
          }}
          submitButtonText="Create"
          onCancel={closeModal}
        />
      </CommonModal>
    </div>
  );
};

export default AddStaffDirectory;
